import React from 'react';
import { StytchB2BProvider } from '@stytch/react/b2b';
import { createStytchB2BUIClient } from '@stytch/react/b2b/ui';

// Create Stytch B2B UI client (for prebuilt components + headless token auth)
const stytch = createStytchB2BUIClient(
  import.meta.env.VITE_STYTCH_PUBLIC_TOKEN || 'public-token-test-fbcc34b7-c312-4a9c-920b-b8f86273ad07'
);

// Export the stytch client for direct access (needed to get JWT)
export { stytch };

interface StytchProviderProps {
  children: React.ReactNode;
}

export const StytchProvider: React.FC<StytchProviderProps> = ({ children }) => {
  return (
    <StytchB2BProvider stytch={stytch}>
      {children}
    </StytchB2BProvider>
  );
};
